import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col pt-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold pt-4" }, "Contact info", -1)
const _hoisted_3 = { class: "flex flex-row py-1" }
const _hoisted_4 = { class: "text-gray-400 w-48" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.harcoded, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `${index + 1}-item-element`,
        class: "flex flex-col pt-1"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1),
          (item.type === 'normal')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(
            item.info && item.info !== null ? 'text-black' : 'text-primary-dark'
          )
              }, _toDisplayString(item.info && item.info !== null ? item.info : "No information"), 3))
            : _createCommentVNode("", true),
          (item.type === 'link')
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: item.info,
                style: _normalizeStyle(
            item.info && item.info !== null ? {} : { cursor: 'not-allowed' }
          ),
                target: "_blank",
                class: _normalizeClass(
            item.info && item.info !== null ? 'text-black' : 'text-primary-dark'
          )
              }, _toDisplayString(item.info && item.info !== null ? item.info : "No information"), 15, _hoisted_5))
            : _createCommentVNode("", true),
          (item.type === 'status')
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: _normalizeClass(["capitalize", 
            item.info && item.info === 'active'
              ? 'text-green-500'
              : 'text-red-500'
          ])
              }, _toDisplayString(item.info && item.info === "active" ? item.info : "inactive"), 3))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Divider, { height: "px" })
      ]))
    }), 128))
  ]))
}